import { Item } from "@radix-ui/react-dropdown-menu";
import { forwardRef } from "react";

const DropdownMenuItem = forwardRef<
  React.ElementRef<typeof Item>,
  React.ComponentPropsWithoutRef<typeof Item> & {
    inset?: boolean;
  }
>(({ className, inset, ...props }, ref) => (
  <Item
    ref={ref}
    className={`relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-hidden transition-colors focus:bg-muted dark:bg-muted/10 focus:text-accent-foreground data-disabled:pointer-events-none data-disabled:opacity-50
      ${inset && "pl-8"}
      ${className}
    `}
    {...props}
  />
));
DropdownMenuItem.displayName = Item.displayName;

export { DropdownMenuItem };
